// The payload signed by digital-services and handed to the ProsperStack flow.
// Key order matters only in that DS signs JSON.stringify(payload) as given.
//
// `scheduled_plan_id` is the plan of a downgrade the member already accepted
// (a Chargebee ramp, applied at term end; '' when none). Chargebee keeps the
// old plan until then, so ProsperStack segments on this property to stop
// offering the same downgrade again.
export const buildFlowPayload = (clientId: string, subscription) => {
  const subId = subscription.subscriptionId || subscription.id || subscription._id;
  return {
    clientId,
    subscription: {
      platformId: subId.toString(),
      properties: {
        scheduled_plan_id: subscription?.scheduledPlanChange?.toItemPriceId || '',
      },
    },
  };
};
